module.exports = __webpack_public_path__ + "efd827f31c0ae73083289137ba26549b.svg";